export default __webpack_public_path__ + "static/media/icon-cross-red.270cbfdf.svg";